<template>
    <div class="row">
        <div class="col-md-6">
            <div class="alert alert-danger" role="alert" v-if="loadError">
                Неполучилось загрузить данные. Попробуйте перезагрузить страницу.
            </div>
            <h5>DPD</h5>
            <div class="form-group">
                <template v-for="(el, i) in fields">
                    <label v-bind:key="'f_'+i" for="account">clientNumber ({{ i }}):</label>                    
                    <div v-bind:key="'a_'+i" class="input-group mb-2">
                        <input type="text" class="form-control" id="account" v-model="el.clientNumber">
                        <div class="input-group-append">
                            <button v-on:click="removeField(i)" class="btn btn-outline-danger" type="button"><i class="fas fa-times"></i></button>
                        </div>
                    </div>
                    <label v-bind:key="'la_'+i" for="secure">clientKey ({{ i }}):</label>
                    <input v-bind:key="'s_'+i" type="text" class="form-control mb-4" id="secure" v-model="el.clientKey">
                </template>
            </div>
            <button type="button" class="btn btn-primary" v-on:click="save">Сохранить</button>
            <button v-on:click="addField" type="button" class="btn btn-outline-primary ml-2"><i class="fas fa-plus"></i></button>
            <div v-if="isHelp">
                <div v-for="(el, i) in alert_s" v-bind:key="'as_'+i" class="row mb-2 alert" v-bind:class="{'alert-success': el.type === 'success', 'alert-danger': el.type === 'error', 'alert-warning': el.type === 'warning'}" role="alert">clientNumber/clientKey ({{ el.id }}): {{ el.status }}</div>
            </div>
        </div>
        <div class="d-flex flex-column flex-grow col-md-6">
            <div class="row d-flex flex-row justify-content-end">
                <i v-on:click="isHelp = !isHelp" class="fas fa-question help-icon"></i>
            </div>
            <div v-if="!isHelp">
                <div v-for="(el, i) in alert_s" v-bind:key="'al_'+i" class="row mb-2 alert" v-bind:class="{'alert-success': el.type === 'success', 'alert-danger': el.type === 'error', 'alert-warning': el.type === 'warning'}" role="alert">clientNumber/clientKey ({{ el.id }}): {{ el.status }}</div>
            </div>
            <div v-if="isHelp" class="row sp-c">
                <p>
                    <ol>
                        <li>В личном кабинете, в левом меню перейти в раздел “Получение ключа для интеграции” <a href="https://www.dpd.ru/ols/order/personal/integrationKey.do2" target="_blank">dpd.ru/ols/order/personal/integrationKey.do2</a>. Нажмите на кнопку “отправить”. Ключ для интеграции придет на вашу почту (клиентский номер отображается в личном кабинете справа, поле “Клиент”)<br></li>
                        <li>Необходимо отправить письмо для подключения к сервису отслеживания:<br>
                        <ul>
                            <li>адрес: itcustomers@dpd.ru</li>
                            <li>тема: Отслеживание отправлений</li>
                            <li>текст: Подключите отслеживание посылок через API. Для клиента № кабинета, «без подтверждения»</li>
                        </ul></li>
                    </ol>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import urls from '@/lib/urls'
import common from '@/lib/common'

export default {
  name: 'DPD',
  data: function () {
    return {
      alert_s: '',
      alert_e: '',
      loadError: false,
      domain: '',
      fields: [{
        clientNumber: '',
        clientKey: ''
      }],
      isHelp: false,
    }
  },
  async created() {
    const self = this

    axios.get(urls.getSettings, await common.setAuthorizationHeader()).then((response) => {
      if (Array.isArray(response.data.dpd)) {
        if(response.data.dpd.length === 0){
          self.isHelp = true
        } else{
          self.fields = response.data.dpd
        }
      } else {
        self.fields[0].clientNumber = response.data.dpd.clientNumber
        self.fields[0].clientKey = response.data.dpd.clientKey
      }
    }).catch(error => {
      let errorParsed = common.errorQueryHandler(error)

      if (errorParsed.type === 'unauthorization') {
        common.queryRefreshToken(error).then(response => {
          if (Array.isArray(response.data.dpd)) {
            if(response.data.dpd.length === 0){
              self.isHelp = true
            } else{
              self.fields = response.data.dpd
            }
          } else {
            self.fields[0].clientNumber = response.data.dpd.clientNumber
            self.fields[0].clientKey = response.data.dpd.clientKey
          }
        }).catch(err => {
          self.loadError = true
          console.log('Error - ' + error)
        })
      } else if (errorParsed.type === 'some') {
        self.loadError = true
        console.log('Error - ' + error)
      } else {
        self.loadError = true
        console.log('Error - ' + error)
      }
    })
  },
  methods: {
    removeField: function (i) {
      if (this.fields.length == 1) {
        this.fields[0].clientNumber = ''
        this.fields[0].clientKey = ''
      } else {
        this.fields.splice(i, 1)
      }
    },
    addField: function () {
      let el = {
        clientNumber: '',
        clientKey: ''
      }
      this.fields.push(el)
    },
    save: async function () {
      const self = this

      this.alert_s = ''
      this.alert_e = ''
      this.alert_s_show = false
      this.alert_e_show = false

      if (this.fields.length < 1) {
        this.alert_s = []
        let el = {
          id: 0,
          type: 'warning',
          status: 'Добавьте поля!'
        }
        this.alert_s.push(el)
      } else if (this.fields[0].clientNumber != '' && this.fields[0].clientNumber != ' ' && this.fields[0].clientKey != '' && this.fields[0].clientKey != ' ') {
        this.fields = this.fields.filter(n => n.clientNumber && n.clientKey)

        let postData = {
          dpd: this.fields
        }

        axios.post(urls.saveSettings, postData, await common.setAuthorizationHeader()).then(response => {
          let s = response.data.dpd.length
          self.alert_e = []
          self.alert_s = []
          for (let i = 0; i < s; i++) {
            if (response.data.dpd[i].status.match("Ошибка")) {
              let el = {
                id: i,
                type: 'error',
                status: response.data.dpd[i].status
              }
              self.alert_s.push(el)
            } else {
              let el = {
                id: i,
                type: 'success',
                status: response.data.dpd[i].status
              }
              self.alert_s.push(el)
            }
          }
        }).catch(error => {
          let errorParsed = common.errorQueryHandler(error)

          if (errorParsed.type === 'unauthorization') {
            common.queryRefreshToken(error).then(response => {
              let s = response.data.dpd.length
              self.alert_e = []
              self.alert_s = []
              for (let i = 0; i < s; i++) {
                if (response.data.dpd[i].status.match("Ошибка")) {
                  let el = {
                    id: i,
                    type: 'error',
                    status: response.data.dpd[i].status
                  }
                  self.alert_s.push(el)
                } else {
                  let el = {
                    id: i,
                    type: 'success',
                    status: response.data.dpd[i].status
                  }
                  self.alert_s.push(el)
                }
              }
            }).catch(err => {
              self.alert_s = []
              let el = {
                id: 0,
                type: 'error',
                status: err
              }
              self.alert_s.push(el)
            })
          } else if (errorParsed.type === 'some') {
            self.alert_s = []
            let el = {
              id: 0,
              type: 'error',
              status: error.error.response.data.errorMessage
            }
            self.alert_s.push(el)
          } else {
            self.alert_s = []
            let el = {
              id: 0,
              type: 'error',
              status: error
            }
            self.alert_s.push(el)
          }
        })
      } else {
        this.alert_s = []
        let el = {
          id: 0,
          type: 'warning',
          status: 'Заполните все поля!'
        }
        this.alert_s.push(el)
      }
    }
  },
}
</script>
<style scope>

</style>
